
import { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { useDispatch, useStore, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { Layout, Menu } from 'antd';
import {
    UserOutlined,
} from '@ant-design/icons';

import Sidebar from "./Sidebar";
import { useTranslation } from "react-i18next";
import { logout } from "../../api/Authentification";

const { Content, Footer } = Layout;
const { SubMenu } = Menu;

const MainLayout = ({ children }) => {
    const [marginLeft, setMarginLeft] = useState(200);
    const [cookie, setCookie] = useCookies(['user']);
    const [userName, setUserName] = useState('');
    const dispatch = useDispatch();
    const store = useStore();
    const token = useSelector(state => state.login.token);
    const user = useSelector(state => state.login.user);
    const headers = { Authorization: `Bearer ${token}` };
    const { first_name, last_name } = store.getState().login.user;
    const [t] = useTranslation('global');

    useEffect(() => {
        try {
            setUserName(`${first_name} ${last_name || ''}`);
        } catch (error) { }
    }, [store]);

    const closeSession = async () => {
        await logout({ headers, data: { user_id: user.id } });
        if (cookie) {
            setCookie('user', null, {
                path: "/",
                maxAge: 0, // Expires right now
                sameSite: true,
            });
        }
        dispatch({ type: 'CLOSE_SESSION' });
    }

    return (
        <Layout style={{ minHeight: '100vh' }}>
            {/* Barra de navegación lateral */}
            <Sidebar setMarginLeft={setMarginLeft} />
            <Layout className="site-layout" style={{ marginLeft, transition: 'all 0.2s' }}>
                <Menu theme="dark" mode="horizontal" style={{ justifyContent: 'flex-end' }}>
                    {/* <SubMenu key="notifications" icon={<BellOutlined />} title="Notificaciones">
                        <Menu.Item key="setting:1">No hay notificaciones</Menu.Item>
                    </SubMenu> */}
                    <SubMenu key="user" icon={<UserOutlined />} title={userName}>
                        <Menu.Item key="logout" onClick={closeSession}>{t('layouts.layout.close-session')}</Menu.Item>
                    </SubMenu>
                </Menu>
                <Content style={{ margin: '0 16px' }}>
                    {/* Miga de pan (Navegación secundaria) */}
                    {/* <BreadcrumbComponent /> */}
                    <section className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
                        {/* Swich de Route DOM (Donde pasan los componentes que son renderizados) */}
                        {children}
                    </section>
                </Content>
                <Footer style={{ textAlign: 'center' }}>{t('layouts.layout.footer')}</Footer>
            </Layout>
        </Layout>
    );
}

MainLayout.propTypes = {
    children: PropTypes.node.isRequired
}

export default MainLayout;